// import Switch from '@components/Gui/Switch';
// import MiniLoading from '@components/Gui/MiniLoading';
//import { getValidText } from '@libs/NwUtils';
// import { NwButton } from "@components/Gui/NwButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { Tag } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

import { MailLine, PhoneLine } from '@components/Gui/NwContactInfo';
import NwDrawer from '@components/Gui/NwDrawer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import NwEllipsis from '@components/Gui/NwEllipsis';
import NwIcon from '@components/Gui/NwIcon';
import ObjectLogHistories from '@components/ObjectLogHistories/ObjectLogHistories';
import AddCallSheet from '@components/Project/ProjectContacts/AddCallSheet';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

//import { getContactName } from '@hooks/Contact/UseContactsList';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.25rem;

    .callsheet-firstline {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;

        .address-book-plus {
            font-size: 2rem;
            cursor: pointer;
            svg {
                &.base-address-book {
                    right: 0.5rem;
                    top: 0.5rem;
                    bottom: auto;
                    left: auto;
                }
                &.stacked-plus {
                    font-size: 1.25rem;
                    top: 0;
                    right: 0;
                    bottom: auto;
                    left: auto;
                    --fa-secondary-opacity: 1;
                    --fa-primary-opacity: 1;
                    --fa-secondary-color: ${(props) => props.theme.PrimaryColor};
                    --fa-primary-color: #fff;
                }
            }
        }
    }

    .callsheet-content {
        flex: 1 1 0;
        .callsheet-details {
            line-height: 1.2;

            .name {
                font-weight: bold;
                color: ${(props) => props.$hidden && props.theme.DangerColor};
                font-size: ${(props) => props.theme.FontSizeLg};
            }
            .description {
                //text-transform: uppercase;
                white-space: pre-wrap;
                font-size: 0.75rem;
                margin-top: 4px;
            }
            .disabled-text {
                color: ${(props) => props.theme.DisabledTextColor};
                text-transform: uppercase;
                margin-top: 1rem;
                font-size: ${(props) => props.theme.FontSizeSm};
            }
        }
    }

    .callsheet-footer {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0.25rem 1rem;
        flex-wrap: wrap;
        text-align: right;
    }
`;

const CallSheetTypeTag = styled(Tag)`
    background-color: ${(props) =>
        props.$empty
            ? props.theme.DisabledTextColor
            : props.$hidden
              ? props.theme.DangerColor
              : props.theme.PrimaryColor};
    border-color: ${(props) =>
        props.$empty ? 'none' : props.$hidden ? props.theme.DangerColor : props.theme.PrimaryColor};
    color: white;
    svg {
        margin-right: 4px;
    }
`;

const ProjectCallSheet = ({ callsheet, onUpdateCallSheet, isempty = false, currentProject }) => {
    const [isAddDrawer, setAddDrawer] = useState(false);
    const [isEditDrawer, setEditDrawer] = useState(false);
    const [touchForm, setTouchForm] = useState(false);

    const handleRemoveCallsheet = async (callsheetID) => {
        try {
            await Axios.delete(`/callsheets/${callsheetID}`);
            onUpdateCallSheet();
        } catch (error) {
            console.error('Delete Callsheet Error => ', error);
        }
    };

    const handleEditCallsheet = () => {
        setEditDrawer(true);
    };

    if (isempty) {
        return (
            <Wrapper>
                <div className="callsheet-firstline">
                    <CallSheetTypeTag $empty>{callsheet.Name}</CallSheetTypeTag>
                    <span onClick={() => setAddDrawer(true)} className="address-book-plus fa-layers fa-fw fa-lg">
                        <FontAwesomeIcon className="base-address-book" icon={byPrefixAndName.fasl['address-book']} />
                        <FontAwesomeIcon className="stacked-plus" icon={byPrefixAndName.fasds['circle-plus']} />
                    </span>
                </div>
                <div className="callsheet-content">
                    <div className="callsheet-details">
                        <div className="disabled-text">not defined</div>
                    </div>
                </div>
                {isAddDrawer && (
                    <NwDrawer
                        touchForm={touchForm}
                        onTouchForm={setTouchForm}
                        title={'Add Contact'}
                        onClose={() => setAddDrawer(false)}
                        whiteBg={false}
                    >
                        <AddCallSheet
                            callSheetType={callsheet.ID}
                            currentProject={currentProject}
                            onUpdateCallSheet={onUpdateCallSheet}
                            onClose={() => setAddDrawer(false)}
                            onTouchForm={setTouchForm}
                        />
                    </NwDrawer>
                )}
            </Wrapper>
        );
    }

    return (
        <Wrapper $hidden={callsheet.Internal}>
            <div className="callsheet-firstline">
                <CallSheetTypeTag $hidden={callsheet.Internal}>
                    {callsheet.Internal && <NwIcon icon={byPrefixAndName.fasl['lock-alt']} />}
                    {callsheet.CallSheetType.Name}
                </CallSheetTypeTag>
                <NwDropDownMenu
                    size="small"
                    actions={[
                        {
                            name: '',
                            key: 'edit',
                            pinned: true,
                            icon: byPrefixAndName.fasl['pen'],
                            action: () => handleEditCallsheet(callsheet),
                        },
                        {
                            name: 'add another',
                            key: 'add',
                            icon: byPrefixAndName.fasl['user-plus'],
                            action: () => setAddDrawer(true),
                        },
                        {
                            name: 'delete',
                            type: 'delete',
                            key: 'delete',
                            icon: byPrefixAndName.fasl['trash-alt'],
                            confirmationPlacement: 'left',
                            action: () => handleRemoveCallsheet(callsheet.ID),
                        },
                    ]}
                />
            </div>
            <div className="callsheet-content">
                <div className="callsheet-details">
                    <div>
                        <div className="name">
                            {callsheet.Name}
                            {callsheet.Connection && callsheet.Connection.ContactID && (
                                <small style={{ marginLeft: '0.5rem' }}>
                                    <NwIcon icon={byPrefixAndName.fasl['link']} />
                                </small>
                            )}
                        </div>
                        <NwEllipsis className="description" popover text={callsheet.Note} rows={4} />
                    </div>
                </div>
            </div>
            <div className="callsheet-footer">
                {callsheet.Email && <MailLine justify="flex-start" mailAddress={callsheet.Email} noIcon />}
                {callsheet.Phone && (
                    <PhoneLine justify="flex-start" phoneType="mobile" phoneNumber={callsheet.Phone} noIcon />
                )}
            </div>
            {isEditDrawer && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title={'Edit Contact'}
                    onClose={() => setEditDrawer(false)}
                    whiteBg={false}
                >
                    <AddCallSheet
                        callsheet={callsheet}
                        currentProject={currentProject}
                        onUpdateCallSheet={onUpdateCallSheet}
                        onClose={() => setEditDrawer(false)}
                        onTouchForm={setTouchForm}
                    />
                </NwDrawer>
            )}
            {isAddDrawer && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title={'Add Contact'}
                    onClose={() => setAddDrawer(false)}
                    whiteBg={false}
                >
                    <AddCallSheet
                        callSheetType={callsheet.CallSheetType.ID}
                        currentProject={currentProject}
                        onUpdateCallSheet={onUpdateCallSheet}
                        onClose={() => setAddDrawer(false)}
                        onTouchForm={setTouchForm}
                    />
                </NwDrawer>
            )}
        </Wrapper>
    );
};

export default ProjectCallSheet;
